export default "__VITE_ASSET__BNxiJDUn__"